import React from 'react';
import { Link } from 'react-router-dom';
import { formatRelativeTime } from '../feedUtils';

interface CompactEventRowProps {
  to: string;
  track: string;
  icon: React.ReactNode;
  /** Tailwind classes for the icon bubble, e.g. "bg-amber-100 text-amber-600" */
  iconClassName: string;
  /** Short label for screen readers and tests, e.g. "Play Milestone" */
  label: string;
  createdAt: string;
  thumbnail?: string | null;
  children: React.ReactNode;
}

/** One-line feed entry for small events (milestones, streaks, new players/games). */
export const CompactEventRow: React.FC<CompactEventRowProps> = ({
  to,
  track,
  icon,
  iconClassName,
  label,
  createdAt,
  thumbnail,
  children,
}) => (
  <Link
    data-track={track}
    to={to}
    className="flex items-center gap-3 min-h-[44px] px-3 py-2 bg-surface rounded-lg border border-edge hover:bg-surface-hover transition-colors duration-150"
  >
    {thumbnail ? (
      <img
        src={thumbnail}
        alt=""
        className="h-8 w-8 flex-shrink-0 rounded object-cover"
        onError={(e) => {
          e.currentTarget.style.display = 'none';
        }}
      />
    ) : (
      <span className={`flex-shrink-0 h-8 w-8 rounded-full flex items-center justify-center ${iconClassName}`}>
        {icon}
      </span>
    )}
    <p className="flex-1 min-w-0 text-sm text-body leading-snug">
      <span className="sr-only">{label}: </span>
      {children}
    </p>
    <span className="flex-shrink-0 text-xs text-muted tabular-nums">{formatRelativeTime(createdAt)}</span>
  </Link>
);
